import { styled } from '@mui/material';
import { Flex } from '../Flex';
import { getColor } from '../../../constants/colors';

export const StyledTooltipTitle = styled(Flex)`
  background: ${getColor('catskillGray')}
  padding: 1rem;
  align-items: center;
`;
